import React, { useState, useEffect } from 'react';
import { Map, AlertTriangle } from 'lucide-react';

const StreetView = ({ coords }) => {
    // IMPORTANT: Replace 'YOUR_GOOGLE_MAPS_API_KEY' with a valid Google Maps API Key
    // that has the "Maps Embed API" enabled in the Google Cloud Console.
    // Or configure it in your .env file as REACT_APP_GOOGLE_MAPS_API_KEY
    const envKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
    const apiKey = (envKey && envKey !== 'YOUR_API_KEY_HERE') ? envKey : 'YOUR_GOOGLE_MAPS_API_KEY';
    const [loadError, setLoadError] = useState(false);

    useEffect(() => {
        // Debugging for developer: check if key is loaded
        if (process.env.NODE_ENV === 'development') {
            console.log('[StreetView] API Key Status:', envKey ? 'Loaded (starts with ' + envKey.substring(0, 4) + '...)' : 'Not Loaded/Missing');
        }
    }, [envKey]);

    if (!coords || !coords.lat || !coords.lng) {
        return (
            <div className="h-full w-full bg-slate-100 dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 flex flex-col items-center justify-center text-slate-400">
                <Map className="w-12 h-12 mb-2 opacity-50" />
                <span className="text-sm">Selecione um local para visualizar o Street View</span>
            </div>
        );
    }

    if (loadError) {
        return (
            <div className="h-full w-full bg-slate-100 dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 flex flex-col items-center justify-center text-slate-500 p-4 text-center">
                <AlertTriangle className="w-10 h-10 mb-2 text-amber-500 opacity-80" />
                <span className="text-sm font-medium">Não foi possível carregar o Street View.</span>
                <span className="text-xs mt-1 text-slate-400">Verifique a chave da API ou a disponibilidade no local.</span>
            </div>
        );
    }

    const { lat, lng } = coords;
    // Using the official Google Maps Embed API
    const url = `https://www.google.com/maps/embed/v1/streetview?key=${apiKey}&location=${lat},${lng}&heading=0&pitch=0&fov=90`;

    return (
        <div className="h-full w-full rounded-xl overflow-hidden shadow-lg border border-slate-200 dark:border-slate-700 bg-black relative group">
             <iframe
                title="Google Street View"
                width="100%"
                height="100%"
                frameBorder="0"
                style={{ border: 0 }}
                src={url}
                allowFullScreen
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                onError={() => setLoadError(true)}
            ></iframe>

            {/* Overlay hint if key is default/missing (for developer awareness) */}
            {(apiKey === 'YOUR_GOOGLE_MAPS_API_KEY' || !apiKey) && (
                <div className="absolute top-0 left-0 right-0 bg-yellow-100 text-yellow-800 text-xs p-2 text-center opacity-90 z-20">
                    <strong>Atenção:</strong> Configure uma chave válida da Google Maps API (Maps Embed API) em <code>.env</code> ou <code>StreetView.js</code>.
                    <br/><span className="text-[10px] text-slate-600">(Reinicie o servidor React após alterar o .env)</span>
                </div>
            )}
        </div>
    );
};

export default StreetView;
